export default __webpack_public_path__ + "static/media/animation3.03f286a6.gif";